import axios from 'axios'
import React from 'react'
import { baseUrl } from '../../config/clientsConfig'

const HotLeadService = {
    getHotLeadsList : async (data) =>{
        return axios.post(`${baseUrl}/leads/getHotLeads `, data)
    },
    convertHotLeads : async (data) =>{
        return axios.post(`${baseUrl}/leads/convertHotLead` , data)
    },
    cancelHotLeads : async (data) =>{
        return axios.post(`${baseUrl}/leads/rejectHotLead` , data)
    },
    getHotLeadHistory : async (id)=>{
        return axios.get(`${baseUrl}/leads/getHotLeadHistory?leadId=${id}`)
    },
    getHotLeadCount : async ()=>{
        return axios.get(`${baseUrl}/leads/getHotLeadCount`)
    }
    
}

export default HotLeadService